module.exports = {
	"firstName": "charlotte",
	"name": "charlotte martin",
	"shortname": "charlotte-martin",
	"website_handle": "iamcharlottemartin.com",
	"website_url": "http://www.iamcharlottemartin.com/",
	"instagram_handle": "iamcharlottemartin",
	"instagram_url": "https://www.instagram.com/iamcharlottemartin/",
	"description": "Charlotte is an artsy soul living in Manchester, United Kingdom, sharing her opinion on fashion and trends throughout her different social media channels. Her unique style, pose and presence are a combination of a tough attitude and edgy personality, which are both represented well in her Noisy may collaboration.",
	"interview": [
		{
			"title": "1. How does your collection represent who you are?",
			"description": "My collection represents me because all of the pieces are everyday basics. For me, they all blend well into my wardrobe, they can be combined with other styles, they can be put on separately but they also work well together. I wanted to create something authentic and reliable."
		},
		{
			"title": "2. If you had to choose a historical fashion idol who would it be?",
			"description": "If there is a name that is recurrent in my mood board it has to be Debbie Harry, the lead singer from the band Blondie. What makes her my historical fashion idol is really her two-toned bleached-blonde hair, her attitude and her unique style."
		},
		{
			"title": "3. Make up or no Make up?",
			"description": "I’d have to say make up, everyday. Nevertheless, wearing makeup doesn’t necessarily mean that it has to be complicated. A winged eyeliner is just what I need."
		}
	],
	"quote": "I’ve created the wardrobe staples I didn’t know I needed",
	"media": [
		"/media/img/influencers/charlotte/charlotte-martin_slider-1.jpg",
		"/media/img/influencers/charlotte/charlotte-martin_slider-2.jpg",
		"/media/img/influencers/charlotte/charlotte-martin_slider-3.jpg"
	],
	"socialItems": [
		{
			"url": "https://www.instagram.com/p/BI-MVclBrf-/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/13767613_1134743523235862_2109353303_n.jpg?ig_cache_key=MTMxNDU0MjM5MTU5MTg3NjYwNg%3D%3D.2",
			"likes": 363
		},
		{
			"url": "https://www.instagram.com/p/BJgI3YsBoSs/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/s750x750/sh0.08/e35/14099262_1788103078068499_1410840358_n.jpg?ig_cache_key=MTMyNDA5NzI4MDg5ODY2MzU5Ng%3D%3D.2",
			"likes": 402
		},
		{
			"url": "https://www.instagram.com/p/BKZ-NFphVws/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/14359568_181713422263993_1571046557_n.jpg?ig_cache_key=MTM0MDM3NTk0MjQyMTYzNDA5Mg%3D%3D.2",
			"likes": 476
		},
		{
			"url": "https://www.instagram.com/p/BMMG-ReBnY9/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/14607040_179862915804034_3239031478696280064_n.jpg?ig_cache_key=MTM3MjUwMjY1NDA4NTEzMzg4NQ%3D%3D.2",
			"likes": 1039
		},
		{
			"url": "https://www.instagram.com/p/BNfLjnthiR3/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/15251667_356787264688932_7290025154606792704_n.jpg?ig_cache_key=MTM5NTg4NTIzNTg0MTE0ODAyMw%3D%3D.2",
			"likes": 1665
		},
		{
			"url": "https://www.instagram.com/p/BMOrNFoBEne/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/14718456_282906378770455_6536365789816029184_n.jpg?ig_cache_key=MTM3MzIyNDk1MTc4NzgzMzgyMg%3D%3D.2",
			"likes": 1504
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./data/influencers/charlotte-martin.json
// module id = 74
// module chunks = 0